<template>
  <div class="block">
    <div class="block__item block__intro">
      <div class="block__intro-item">
        <h1>Настройте номинации</h1>
      </div>
      <div class="block__intro-item">
        <div class="text-md">
          На&nbsp;основе номинаций формируются рейтинги и&nbsp;определяются победители чемпионата
        </div>
      </div>
    </div>
    <div class="block__item">
      <form
        class="form"
        @submit.prevent="submit"
        novalidate
      >
        <div class="form__item">
          <div class="loader m-0" v-show="!ready"></div>
          <div class="grid grid_v-margins grid_gutters-sm" v-show="ready">
            <div
              class="grid__col"
              v-for="(item, i) in nominations"
              :key="item.Id"
            >
              <nomination-card
                :id="item.Id"
                :type="item.AlgorithmType"
                :gender="item.Gender"
                :typeOptions="types"
                :genderOptions="genders"
                @changed="(val) => updateNomination(i, val)"
                @deleting="deleteNomination"
              >
              </nomination-card>
            </div>
            <div class="grid__col" v-show="showErrors && noItems">
              <alert
                type="danger"
                text="Добавьте хотя бы одну номинацию"
              >
              </alert>
            </div>
            <div class="grid__col">
              <button
                class="button button_wide button_secondary button_dashed"
                type="button"
                @click.prevent="addNomination"
                :key="'add' + counter"
              >
                  <span class="button__icon">
                    <icon icon-name="plus"></icon>
                  </span>
                <span class="button__text">Добавить номинацию</span>
              </button>
            </div>
          </div>
        </div>
        <div class="form__item" v-show="ready">
          <div class="divider"></div>
        </div>
        <div class="form__item">
          <div class="grid grid_v-center grid_v-margins">
            <div class="grid__col grid__col_auto mr-auto">
              <button
                class="action color-muted"
                type="button"
                @click="$emit('prev')"
              >
                <span class="action__container">
                   <span class="action__icon">
                     <icon icon-name='left'></icon>
                   </span>
                  <span class="action__text">Назад</span>
                </span>
              </button>
            </div>
            <div class="grid__col grid__col_auto" v-show="ready">
              <button
                class="button button_primary button_lg"
                :class="{'disabled': showErrors && hasErrors, 'button_loading': isSending}"
                :disabled="(showErrors && hasErrors) || isSending"
                type="submit"
              >
                <span class="button__text">Продолжить</span>
                    <span class="button__icon button__loading">
                  <icon icon-name='loading'></icon>
                </span>
                    <span class="button__icon">
                  <icon icon-name='right'></icon>
                </span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import { findIndex, find, cloneDeep, isEqual } from 'lodash'
import champsService from '@/services/champsService'
import NominationCard from '@/components/NominationCard'
import Alert from '@/components/Alert'

export default {
  name: 'ChampNominations',
  props: {
    club: Object,
    champId: String
  },
  components: {
    NominationCard,
    Alert
  },
  data () {
    return {
      id: null,
      clubCode: null,
      counter: 0,
      types: [
        {
          id: 'ByDistanceForTraining',
          name: 'Дистанция',
          title: 'Дистанция'
        }, {
          id: 'ByTimeForTraining',
          name: 'Чистое время',
          title: 'Чистое время'
        }
      ],
      genders: [
        {
          id: 'null',
          name: 'Любой',
          title: null
        }, {
          id: '0',
          name: 'Мужской',
          title: '(муж)'
        }, {
          id: '1',
          name: 'Женский',
          title: '(жен)'
        }
      ],
      nominations: [],
      showErrors: false,
      isSending: false,
      savedData: null,
      ready: false
    }
  },
  computed: {
    noItems () {
      return this.nominations.length < 1
    },
    hasErrors () {
      return this.noItems
    }
  },
  methods: {
    ...mapActions('alerts', ['addSomethingWrongAlert']),
    addNomination () {
      const id = uuidv4()
      this.nominations.push({
        Id: id,
        AlgorithmType: this.types[0].id,
        Gender: this.genders[0].id,
        Name: this.types[0].title
      })
      this.counter += 1
    },
    deleteNomination (id) {
      const index = findIndex(this.nominations, (o) => o.Id === id)
      if (index !== -1) {
        this.nominations.splice(index, 1)
      }
      this.counter += 1
    },
    updateNomination (index, val) {
      const type = find(this.types, (o) => o.id === val.type)
      const gender = find(this.genders, (o) => o.id === val.gender)

      let name = type.title

      if (gender) {
        name += gender.title ? ' ' + gender.title : ''
      }

      this.nominations[index].Id = val.id
      this.nominations[index].AlgorithmType = val.type
      this.nominations[index].Gender = val.gender
      this.nominations[index].Name = name
    },
    submit () {
      this.showErrors = true

      if (this.hasErrors) {
        return
      }

      if (this.savedData && isEqual(this.nominations, this.savedData)) {
        this.$emit('next')
        return
      }

      this.isSending = true

      champsService.editChampNominations({
        champId: this.champId,
        nominations: this.nominations
      })
        .then((res) => {
          const d = res.data
          if (d.Success) {
            this.savedData = cloneDeep(this.nominations)
            this.$emit('changed', this.nominations.length)
            this.$emit('next')
          } else {
            this.addSomethingWrongAlert()
          }
          this.isSending = false
        })
        .catch(() => {
          this.addSomethingWrongAlert()
          this.isSending = false
        })
    },
    getNominations () {
      champsService.getChampNominations({ champId: this.id })
        .then((res) => {
          this.nominations = res.data.Nominations
          this.savedData = cloneDeep(res.data.Nominations)
          this.ready = true
        })
    }
  },
  created () {
    this.clubCode = this.$route.params.id || this.$getTenantIdClub()
    this.id = this.$route.params.champ

    if (this.id) {
      this.getNominations()
      return
    }
    this.addNomination()
    this.ready = true
  }
}
</script>
